import { render, staticRenderFns } from "./CognitiveLevelRow.vue?vue&type=template&id=279e87a0&scoped=true"
import script from "./CognitiveLevelRow.vue?vue&type=script&lang=js"
export * from "./CognitiveLevelRow.vue?vue&type=script&lang=js"
import style0 from "./CognitiveLevelRow.vue?vue&type=style&index=0&id=279e87a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e87a0",
  null
  
)

export default component.exports